module.exports = __webpack_public_path__ + "img/floatPacket.94ba791e.gif";